import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Map from '../components/Map';
import * as SelectionActions from '../actions/selectionActions';
import * as AutoplayActions from '../actions/autoplay';

function mapStateToProps(state) {
  return {
    data: state.data,
    selection: state.selection,
    autoplay: state.autoplay
  };
}

function mapDispatchToProps(dispatch) {
  return {
    selectionActions: bindActionCreators(SelectionActions, dispatch),
    autoplayActions: bindActionCreators(AutoplayActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Map);



/** WEBPACK FOOTER **
 ** ./src/Containers/Map.js
 **/